import React, { Component } from 'react';
import LoggedInContainer from '../../containers/login/LoggedInContainer';
import NavBarContainer from '../../containers/shared/NavBarContainer';
import CurrentOverlayContainer from '../../containers/shared/CurrentOverlayContainer';
import RoutingContainer from '../../containers/shared/RoutingContainer';
/**
 * Renders: {@link NavBarContainer}, {@link CurrentOverlayContainer}, and {@link LoggedInContainer}
 * @returns NavBarContainer, CurrentOverlayContainer and LoggedInContainer
 */
class PageWrapper extends Component { 
	render() {
		const { match } = this.props;
		return <div className ='page_wrapper'> 
			<NavBarContainer 
				match = { match }
			/>
			<RoutingContainer />
			<CurrentOverlayContainer />
			<LoggedInContainer />
			{this.props.children}
		</div>
	}
}

export default PageWrapper;


// WEBPACK FOOTER //
// ./src/components/shared/PageWrapper.js